var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewOne"},[_c('h1',[_vm._v("Hola! Esta es la vista 1")])])
}]

export { render, staticRenderFns }